module.exports = __webpack_public_path__ + "img/15.99b7c9a7.jpg";